import { AutoMap } from "@automapper/classes"

export class ELIMSJobInfoDTO {
    @AutoMap()
    status?: number
    @AutoMap()
    lastError: string = ''
}